<template>
  <button
    @click="$emit('click')"
    :type="type"
    class="btn btn-lg btn-outline-danger btn-block button success"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "BtnOutlineDanger",
  props: {
    type: String,
  },
};
</script>

<style>
.btn-outline-danger {
  border: 1px solid rgb(240, 82, 103);
  color: rgb(240, 82, 103);
  border-width: 2px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  text-transform: none;
  font-size: 16px;
  transition: 0.25s;
  --hover: rgb(240, 82, 103);
  font-weight: 700;
}
.btn-outline-danger:hover,
.btn-outline-danger:focus {
  box-shadow: inset -16em 0 0 0 var(--hover), inset 16em 0 0 0 var(--hover);
  color: #fff;
}
.btn-outline-danger:hover {
  border-color: rgb(240, 82, 103);
}
.btn-outline-danger.animate:focus {
  color: rgb(240, 82, 103);
}
</style>
